export default [
    {
        path: '/presupuesto',
        name: 'presupuesto',
        component: () => import(/* webpackChunkName: "presupuesto" */ '../index.vue'),
    },
    {
        path: '/presupuesto/anual/:id',
        name: 'presupuesto-anual',
        component: () => import(/* webpackChunkName: "presupuesto-anual" */ '../views/PresupuestoAnualView.vue'),
    },
    {
        path: '/presupuesto/anual/:id/cifrados/:unidadId',
        name: 'detalle-cifrado-anual',
        component: () => import(/* webpackChunkName: "detalle-cifrado-presupuesto-anual" */ '../views/DetalleCifradoPresupuestoAnual.vue'),
    },
    {
        path: '/presupuesto/establecimiento/cifrados/:id',
        name: 'asignacion-presupuesto-anual',
        component: () => import(/* webpackChunkName: "asignacion-presupuesto-anual" */ '../views/AsignacionPresupuestoAnual/index.vue'),
    },
    {
        path: '/presupuesto/cifrados-anual/:id',
        name: 'cifrados-presupuesto-anual',
        component: () => import(/* webpackChunkName: "cifrados-presupuesto-anual" */ '../views/CifradoPresupuestoAnual.vue'),
    },
    {
        path: '/presupuesto/movimientos/:id',
        name: 'movimientos-presupuesto-anual',
        component: () => import(/* webpackChunkName: "movimientos-presupuesto-anual" */ '../views/MovimientosPresupuestoAnual.vue'),
    }
]